<div class="login">
    
    <div class="container text-center mt-5 mb-5">
      <img src="../../../../assets/images/realdesk-logo.png">
    </div>

    <div class="container content-login">
      <div class="row">
        
        <div class="col-md-6">
          <img src="../../../../assets/images/ilustration_login.svg" class="img-fluid">
        </div>

        <div class="col-md-6 card">
          <div class="logo-client text-center mb-5 mt-3">
            <!-- <img src="../../../../assets/images/logo-notasimples.png" class="img-fluid"> -->
             <h2>{{nomeEmpresa}}</h2>
          </div>

          <form class="form" [formGroup]="loginForm">
            <div class="mb-3">
              <label class="form-label">Usuário</label>
              <input type="text" class="form-control user" placeholder="Digite seu e-mail" formControlName="email">
                @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['required']) {
                <div class="text text-danger mt-1"> Email é obrigatório</div>
                }
                @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['email']) {
                <div class="text text-danger mt-1">Email inválido</div>
                }
            </div>

            <div class="mb-3">
              <label class="form-label">Senha</label>
              <input type="password" class="form-control pass" placeholder="Digite sua senha" formControlName="password">
                @if (loginForm.controls['password'].touched &&
                loginForm.controls['password'].errors?.['required']) {
                <div class="text text-danger mt-1">
                    senha é obrigatória
                </div>
                }
            </div>

            <div class="mb-3 actions">
                <button  data-cy="btn-submit" class="btn btn-primary mb-3" [disabled]="!loginForm.valid || isLoading"
                    (click)="login()"><i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i>
                    Entrar</button>
                <button data-cy="btn-criar-conta" class="btn btn-outline-primary mb-3" [routerLink]="['/sign-up']">Crie uma conta</button>
                <button data-cy="btn-forgot-password" class="btn btn-link" [routerLink]="['/forgot-password']">Esqueci minha senha</button>
            </div>
            <div>
              <!-- Your login form here -->
              <p style="text-align: center; font-size:x-small">Front-Version: {{ apiVersion }}</p>
              <!-- <button (click)="throwTestError()">Test Sentry Error</button> -->
            </div>
          </form>
        </div>

      </div>
    </div>
</div>